import Icons from './icons';
export default Icons;
